import FileTarget, { FileTargetProps as Props } from './FileTarget';

export type FileTargetProps = Props;

export default FileTarget;
